import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Initialize Web3Modal
import './config/web3modal';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Presale from './pages/Presale';
import OtcMarketplace from './pages/OtcMarketplace';
import OtcSwap from './pages/OtcSwap';
import Login from './pages/Login';
import AuthLayout from './components/layout/AuthLayout';
import Dashboard from './pages/dashboard/Dashboard';
import DashboardLayout from './components/layout/DashboardLayout';
import UserProfile from './pages/dashboard/Profile';
import ViewUsers from './pages/dashboard/Users';
import Adverts from './pages/dashboard/Adverts';
import Orders from './pages/dashboard/Orders';
import CategoryList from './pages/dashboard/Category';
import ComingSoonPage from './components/common/ComingSoon';
import Community from './pages/Community';
import NotFound from './pages/NotFound';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route index element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/presale" element={<Presale />} />
                <Route path="/otc" element={<OtcMarketplace />} />
                <Route path="/otc/:mode" element={<OtcSwap />} />
                <Route path="/community" element={<Community />} />
                <Route path="/coming-soon" element={<ComingSoonPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          }
        />
        <Route
          path="/auth/*"
          element={
            <AuthLayout>
              <Routes>
                <Route index element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthLayout>
          }
        />
        <Route
          path="/admin/*"
          element={
            <DashboardLayout>
              <Routes>
                <Route index element={<Dashboard />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/users" element={<ViewUsers />} />
                <Route path="/adverts" element={<Adverts />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/category" element={<CategoryList />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </DashboardLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
